/** @module Save a file the API sent: the name from Content-Disposition, the bytes as a Blob. */

/** The file name the server suggested, else the fallback. */
export function filenameFrom(response: Response, fallback: string): string {
  const header = response.headers.get("Content-Disposition") ?? "";
  const match = /filename="?([^";]+)"?/.exec(header);
  return match?.[1] ?? fallback;
}

/** Hand a Blob to the browser as a download. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  // Some browsers start the download only after the click handler returns.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
